import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class Type extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			type : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("typeform").reset();
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.type){
			
			PostData('certificate/addtype',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Certificate Type Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("typeform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('certificate/deletetype',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Certificate Type Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		
		GetData('certificate/getctype').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="typeform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Certificate Type</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Certificate Type <span className="text-danger">*</span></Label>
							  <Input type="text" name="type" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Certificate Type</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.posts.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.type}</td>
								<td>
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>

						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Type;


// WEBPACK FOOTER //
// ./src/certificate/Type/Type.js